<template lang="pug">
  form.ema(novalidate, @submit.stop.prevent='submit')
    md-input-container(:class='{"md-input-invalid": hasError}')
      label 現在の所持絵馬数
      md-input(
        :value='ema',
        @input='updateValue'
      )
      span.md-error 正しい数値を入力してください。
</template>

<script>
export default {
  data () {
    return {
      ema: this.$store.state.currentEma + ''
    }
  },
  computed: {
    hasError () {
      return !(/^[1-9][0-9]*$/.test(this.ema) || this.ema === '0' || this.ema === '')
    }
  },
  methods: {
    updateValue (value) {
      this.ema = value
      if (this.hasError) return
      this.$store.commit('updateEma', +this.ema)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .ema
    margin: 0 auto
    width: 70vw
</style>



// WEBPACK FOOTER //
// src/components/EmaInput.vue